import React from 'react';
import { Row, Col, Empty } from 'antd';
import ProductCard from './ProductCard';
import Loader from '../common/Loader';
import { motion } from 'framer-motion';

const ProductList = ({ products, loading }) => {
  if (loading) {
    return <Loader text="Mahsulotlar yuklanmoqda..." />;
  }

  if (!products || products.length === 0) {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={{ textAlign: 'center', padding: '64px 0' }}>
        <Empty description={<span style={{ color: '#64748b', fontSize: '1.1rem' }}>Mahsulotlar topilmadi</span>} />
      </motion.div>
    );
  }

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 300, damping: 24 } }
  };

  return (
    <motion.div variants={container} initial="hidden" animate="show">
      <Row gutter={[16, 20]}>
        {products.map((product) => (
          <Col xs={24} sm={12} md={8} lg={6} xl={4} key={product.id}>
            <motion.div variants={item} style={{ height: '100%' }}>
              <ProductCard product={product} />
            </motion.div>
          </Col>
        ))}
      </Row>
    </motion.div>
  );
};

export default ProductList;
